function closePreorderModal(e, modalMessage, modalOverlay) {
  e.preventDefault();
  modalMessage.classList.add("none");
  modalMessage.classList.remove("active");
  modalOverlay.classList.add("hidden");
}

const generalPreorderModalMessage = document.querySelector(
  ".general-preorder-modal-message",
);

if (generalPreorderModalMessage !== null) {
  const generalPreorderModalTriggers = document.querySelectorAll(
    ".general-preorder-modal-trigger",
  );
  const generalPreorderModalOverlay = document.querySelector(
    ".general-preorder-modal-overlay",
  );
  const generalPreorderModalClose = document.querySelector(
    ".general-preorder-modal-close",
  );
  const generalPreorderModalCloseImg = document.querySelector(
    ".general-preorder-modal-close img",
  );

  generalPreorderModalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      if (
        e.target === generalPreorderModalClose ||
        e.target === generalPreorderModalCloseImg ||
        e.target.tagName === "A"
      ) {
        return;
      }
      e.preventDefault();
      generalPreorderModalMessage.classList.remove("none");
      generalPreorderModalMessage.classList.add("active");
      generalPreorderModalOverlay.classList.remove("hidden");
    });
  });

  generalPreorderModalClose.addEventListener("click", (e) => {
    closePreorderModal(
      e,
      generalPreorderModalMessage,
      generalPreorderModalOverlay,
    );
  });

  generalPreorderModalOverlay.addEventListener("click", (e) => {
    closePreorderModal(
      e,
      generalPreorderModalMessage,
      generalPreorderModalOverlay,
    );
  });
}
